import React from 'react';
import { SurveyFactory } from '@bingads-webui-campaign-react/survey-factory-tools';
import { CopilotAssetRecommendationSatisfactionSurveyConfig } from './factory-view';

export const CopilotAssetRecommendationSatisfactionSurveyView = props => (
  <SurveyFactory
    getSurveyConfiguration={CopilotAssetRecommendationSatisfactionSurveyConfig}
    {...props}
  />
);
